import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button, Tabs, Divider, Descriptions } from 'antd'

import {
  CreditCardOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  CommentOutlined,
  ImportOutlined
} from '@ant-design/icons'

import BannerNotAvailable from '../../../../components/event/banner/notAvailable'
import FormNotAvailable from '../../../../components/event/form/notAvailable'

import Profile from '../../../../core/components/profile'
import VendorInformation from '../../../../components/vendor/profile/information'
import VendorDetails from '../../../../components/vendor/profile/details'

import { flashError } from '../../../../core/utils/flashMessage'

import FileManager from './files'

import PaymentMethod from '../../../../components/payment/method'
//import AccountList from "../../../../components/account/list";
import Bitacora from '../../../../components/bitacora'
import PriceList from '../../../../components/price/list'

import { LAYOUT_MANAGER_VENDOR_EDIT } from '../../navigation'
import { LAYOUT_FINANCE_PAYMENT_VENDOR_NEW } from '../../../../layouts/finance/navigation'

const { TabPane } = Tabs

class Show extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      id: props.match.params.id,
      loading: false,
      modalVisible: false
    }
  }

  showModal = () => {
    this.setState({ modalVisible: true })
  }

  handleCancel = () => {
    this.setState({ modalVisible: false })
  }

  _goBack = () => {
    this.props.history.goBack()
  }

  _createStorage = () => {
    this.setState({ loading: true })

    const ret = this.props.createStorageFolder(this.state.id)
    ret.then((response) => {
      // flashSuccess({ description: "Folder created" });
      this.setState({ loading: false })
    }).catch((e) => {
      flashError({ description: 'Unexpected error!' })
      this.setState({ loading: false })
    })
  }

  _addPayment = () => this.props.history.push(LAYOUT_FINANCE_PAYMENT_VENDOR_NEW(this.props.data.vendor.id))

  render () {
    const { data } = this.props
    const { vendor, events } = data
    const { storageData } = this.props

    const createEventNotAvailable = (form) => this.props.createEventNotAvailable(vendor.id, form)
    const dismissEvent = (eid) => this.props.dismissEvent(vendor.id, eid)

    return (
      <>
        <BannerNotAvailable vendor events={events} dismissEvent={dismissEvent} />

        <Profile
          onBack={this._goBack}
          mainTitle='Vendor'
          ainSubtitle='subtitle'
          mainExtra={[
            <Button
              key='ooo'
              type='default'
              size='small'
              icon={<ImportOutlined />}
              onClick={this.showModal}
            >
              Not Available
            </Button>,
            <Link key='1' to={LAYOUT_MANAGER_VENDOR_EDIT(this.state.id)}>
              <Button type='primary' size='small'>
                <i className='fa fa-pencil-square-o' />
                <Divider type='vertical' />
                Update
              </Button>
            </Link>
          ]}
          renderInformation={() => (
            <VendorInformation
              vendor={vendor}
              priorities={this.props.priorities}
              updatePriority={this.props.updatePriority}
              managerMode
            />
          )}
        >
          <>
            <VendorDetails vendor={vendor} />
            <Divider orientation='left' plain />

            <Tabs
              defaultActiveKey='1'
              ize='small'
              tyle={{ padding: '10px 20px' }}
              xstyle={{ marginBottom: 32, marginTop: 32, backgroundColor: '#fff' }}
            >
              <TabPane
                tab={
                  <span>
                    {' '}
                    <DollarOutlined /> Basic Prices{' '}
                  </span>
                }
                key='prices'
                style={{ minHeight: 400 }}
              >
                <Descriptions size='medium' column={1}>
                  <Descriptions.Item label='Currency'>
                    {data.vendor.currency ? data.vendor.currency.name : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label='Rush fee percent'>
                    {' '}
                    {parseFloat(data.vendor.rush_percent).toFixed(0) + '%'}{' '}
                  </Descriptions.Item>
                </Descriptions>
                <br />

                <PriceList
                  prices={vendor.prices}
                  pricesReview={vendor.prices_review}
                  validatePrices={() => this.props.validatePrices(vendor.id)}
                  rejectPrices={() => this.props.rejectPrices(vendor.id)}
                />
              </TabPane>

              <TabPane
                tab={
                  <span>
                    {' '}
                    <CreditCardOutlined /> Payment Methods{' '}
                  </span>
                }
                key='payment'
                style={{ minHeight: 400 }}
              >
                <PaymentMethod
                  vendor={data.vendor}
                  updatePaymentMethod={this.props.updatePaymentMethod}
                  deletePaymentMethod={this.props.deletePaymentMethod}
                  validateChanges={() => this.props.validatePaymentMethod(vendor.id)}
                  rejectChanges={() => this.props.rejectPaymentMethod(vendor.id)}
                />
              </TabPane>
              {this.props.storageAvailable && (
                <TabPane
                  tab={
                    <span>
                      {' '}
                      <FolderOpenOutlined /> Files{' '}
                    </span>
                  }
                  key='files'
                  style={{ minHeight: 400 }}
                >
                  <FileManager
                    id={vendor.id}
                    storage={vendor.storage_private}
                    defaults={storageData.defaults}
                    onCreateStorage={this._createStorage}
                  />
                </TabPane>
              )}
              <TabPane
                tab={
                  <span>
                    {' '}
                    <CommentOutlined /> Logs{' '}
                  </span>
                }
                key='timeline'
                style={{ minHeight: 400 }}
              >
                <Bitacora
                  bitacora={vendor.bitacora}
                  handleSubmit={this.props.postVendorBitacoraMessage(vendor.id)}
                />
              </TabPane>
            </Tabs>
          </>

          {this.state.modalVisible && (
            <FormNotAvailable
              createEventNotAvailable={createEventNotAvailable}
              onCancel={this.handleCancel}
              modalVisible={this.state.modalVisible}
            />
          )}
        </Profile>
      </>
    )
  }
}

export default Show

/*

const exampleData = [
  'Branding',
  'UI/UX',
  'Web - Design',
  'Packaging',
  'Print & Editorial',
];


                        <TabPane
                            tab={
                                <span style={{fontSize: '18', fontWeight: '500'}}>
                                    Basic Prices
                                </span>
                            }
                            key="price"
                            style={{ minHeight: 400  }}
                        > 



                      <div className="user-details">
                        <span className="floating-icon"><StarFilled /></span>
                        <div className="work-experience">
                          <h2 className="after-underline">Work</h2>
                          <div className="m-b-10 m-t-15">
                            <h3>Spotify New York</h3>
                            <span>2015 - Present</span>
                          </div>
                          <p className="m-b-25">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            <br />{' '}

                            {' '}
                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                          </p>
                          <div className="m-b-10 m-t-15">
                            <h3>Metropolitan Museum</h3>
                            <span>2013 - 2015</span>
                          </div>
                          <p className="m-b-25">
                            It is a long established fact that a reader will be distracted
                            {' '}
                            by the readable content of a page when looking at its layout. The point of using
                            {' '}
                            Lorem Ipsum is that it has a more-or-less normal distribution of letters,
                            {' '}
                            as opposed to using
                          </p>
                        </div>

                        <h2 className="after-underline">Rankings</h2>
                        <div className="d-flex align-items-center user-ratings">
                          <h1 className="m-r-10">8.6</h1>   
                          <StarFilled />
                          <StarFilled />
                          <StarFilled />
                          <StarFilled />
                          <StarFilled />
                        </div>

                        <div className="m-t-25">
                          <h2 className="after-underline">Languages</h2>
                          <List
                            dataSource={exampleData}
                            renderItem={item => (
                              <List.Item className="skill-item">{item}</List.Item>
                            )}
                          />
                        </div>

                        <div className="m-t-25">
                          <h2 className="after-underline">Service</h2>
                          <List
                            dataSource={exampleData}
                            renderItem={item => (
                              <List.Item className="skill-item">{item}</List.Item>
                            )}
                          />
                        </div>
                         <div className="m-t-25">
                          <h2 className="after-underline">Specializations</h2>
                          <List
                            dataSource={exampleData}
                            renderItem={item => (
                              <List.Item className="skill-item">{item}</List.Item>
                            )}
                          />
                        </div>






                        <div className="m-t-30 m-b-30 user-buttons">
                          <Button><StarFilled /> Send Message</Button>
                          <Button><StarFilled /> Contacts</Button>
                          <Button>Report User</Button>
                        </div>
                      </div>

                        </TabPane>
*/
